import { createSelector } from "reselect";
import { Feed } from "../interfaces/feed";
import { createDBServiceSlice } from "./db-service-reducers"; // Add missing import statement

export const {
    slice: FeedSlice,
    dbThunks: _FeedThunks,
    selectByQuery: _feedSelectByQuery,
    selectOneObjectByQuery: _feedSelectOneObjectByQuery,
    selectOneFieldByQuery: _feedSelectOneFieldByQuery,
    selectors: _feedSelectors,
    selectByQueryOnlyLength: _feedSelectByQueryOnlyLength,
    selectByQueryOnlyMaxMin: _feedSelectByQueryOnlyMaxMin,
} = createDBServiceSlice<Feed>({
    service: "feed",
    initialState: { ids: [], entities: {}, itemsLoaded: false, itemsLoading: false },
    getReducerState: (state) => state.DBFeedReducer,
});
export const DBFeedReducer = FeedSlice.reducer;
export const FeedReducerActions = FeedSlice.actions;
export type feedReducerActions = keyof typeof FeedReducerActions;
export const DBFeedThunks = _FeedThunks;
export const feedSelectors = _feedSelectors;
export const feedSelectByQuery = _feedSelectByQuery;
export const feedSelectByQueryOnlyLength = _feedSelectByQueryOnlyLength;
export const feedSelectByQueryOnlyMaxMin = _feedSelectByQueryOnlyMaxMin;
export const feedSelectOneObjectByQuery = _feedSelectOneObjectByQuery;
export const feedSelectOneFieldByQuery = _feedSelectOneFieldByQuery;

export interface ConnectionSegment {
    feedTag: string;
    channelTag: string;
    connectedAt: Date;
    disconnectedAt?: Date;
}

